import { backgroundLight, textLight } from './defaultConfig';

const productThemes = [
  {
    mode: 'light',
    primary: {
      main: '#231f20', // Black
    },
    secondary: {
      main: '#ffffff', // Dim Gray
    },
    background: backgroundLight, // White
    text: textLight, // Black
    title: 'Black',
  },
  {
    mode: 'light',
    primary: {
      main: '#02217a', // Blue  #02217A
    },
    secondary: {
      main: '#ffffff',
    },
    background: backgroundLight,
    text: textLight,
    title: 'Blue',
  },
  {
    mode: 'light',
    primary: {
      main: '#262f30', // Grey  #262F30
    },
    secondary: {
      main: '#D3D3D3', // Light Grey
    },
    background: backgroundLight, // White
    text: textLight, // Black
    title: 'Dark Gray',
  },
  {
    mode: 'light',
    primary: {
      main: '#008254', // Green #28E100
    },
    secondary: {
      main: '#ffffff', // Lime
    },
    background: backgroundLight, // White
    text: textLight, // Black
    title: 'Green',
  },
  {
    mode: 'light',
    primary: {
      main: '#330066', // Green #28E100
    },
    secondary: {
      main: '#ffffff', // Lime
    },
    background: backgroundLight, // White
    text: textLight, // Black
    title: 'Purple',
  },
  {
    mode: 'light',
    primary: {
      main: '#a5acaf', // Green #28E100
    },
    secondary: {
      main: '#000000', // Lime
    },
    background: backgroundLight, // White
    text: textLight, // Black
    title: 'Silver',
  },
  {
    mode: 'light',
    primary: {
      main: '#b5ccd9', // Light gray #B5CCD9
    },
    secondary: {
      main: '#000000', // Fire Brick
    },
    background: backgroundLight, // White
    text: textLight, // Black
    title: 'Light Gray',
  },
  {
    mode: 'light',
    primary: {
      main: '#d95200', // Orange
    },
    secondary: {
      main: '#ffffff', // Orange
    },
    background: backgroundLight, // White
    text: textLight, // Black
    title: 'Orange',
  },
  {
    mode: 'light',
    primary: {
      main: '#cb0022', // Red #CB0022
    },
    secondary: {
      main: '#ffffff', // Light Salmon
    },
    background: backgroundLight, // White
    text: textLight, // Black
    title: 'Red',
  },
];

export default productThemes;
